/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonial_Sean_GruberInputs */

const en_testimonial_sean_gruber = /** @type {(inputs: Testimonial_Sean_GruberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already thoroughly impressed! I've used Natural Reader for a while, but this is cheaper, designed specifically for academic papers (e.g., organizes into typical paper sections like abstract and findings), and, in my opinion, has a more natural flow in the AI voice. HIGHLY recommend!`)
};

const es_testimonial_sean_gruber = /** @type {(inputs: Testimonial_Sean_GruberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Ya estoy completamente impresionado! He usado Natural Reader por un tiempo, pero esto es más barato, diseñado específicamente para artículos académicos (por ejemplo, organiza en secciones típicas como resumen y hallazgos), y en mi opinión, tiene un flujo más natural en la voz de IA. ¡Lo RECOMIENDO mucho!`)
};

/**
* | output |
* | --- |
* | "Already thoroughly impressed! I've used Natural Reader for a while, but this is cheaper, designed specifically for academic papers (e.g., organizes into typi..." |
*
* @param {Testimonial_Sean_GruberInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonial_sean_gruber = /** @type {((inputs?: Testimonial_Sean_GruberInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonial_Sean_GruberInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonial_sean_gruber(inputs)
	return en_testimonial_sean_gruber(inputs)
});